// extracted by mini-css-extract-plugin
module.exports = {"Content":"MaRTSG","AsideContent":"PKiZXR","Logo":"NePA_d","AsideFooter":"oUyKQI","Collapsed":"EgViDT","Btn":"eqvumf"};